import { Session } from "@mojo/types/src/auth";
import axios from "axios";
import { config } from "../auth.config";

/**
 * Returns the current user session
 */
export const getSession = () => {
  return axios.get<Session>(`${config.PUBLIC_AUTH_API}/session`, {
    withCredentials: true,
  });
};

/**
 * Returns a base64 image of a QR code that, when scanned, shares the user's session to the device that scanned it
 */
export const getSessionQR = () => {
  return axios.get<string>(`${config.PUBLIC_AUTH_API}/session/share`, {
    withCredentials: true,
  });
};
